import { meta } from "@/lib/config";
import { useUserAuth } from "@/lib/utils/hooks/useUserAuth";
import Footer from "../footer";
import NavPrimary from "../nav/nav-primary";
import LayoutPageBlank from "./layout-page-blank";

function LayoutComplete({
  title,
  url,
  ssr_data_tribe,
  image = meta(ssr_data_tribe).image,
  content,
  navtype,
}) {
  const { userdata, isUserDataLoading, isUserDataError } = useUserAuth();

  return (
    <>
      {/* MAIN CONTAINER */}
      <LayoutPageBlank
        title={title}
        url={url}
        image={image}
        ssr_data_tribe={ssr_data_tribe}
      >
        <NavPrimary
          userdata={userdata}
          isUserDataLoading={isUserDataLoading}
          isUserDataError={isUserDataError}
          navtype={navtype}
          ssr_data_tribe={ssr_data_tribe}
        />

        <div className="my-5 px-5">{content}</div>
        <Footer />
      </LayoutPageBlank>
    </>
  );
}

export default LayoutComplete;
